<template>
  <div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-date-picker v-model="time" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['12:00:00']" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.username" placeholder="请输入账号搜索"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getLogList">搜索</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" style="float: right;" @click="delLog">清空日志</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <!--        账号 操作类型 说明 操作时间 登录ip-->
        <el-table-column prop="username" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="client_type" label="操作类型" align="center">
        </el-table-column>
        <el-table-column prop="group_name" label="说明" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="操作时间" align="center">
        </el-table-column>
        <el-table-column prop="ip" label="登录ip" align="center">
        </el-table-column>
      </el-table>
      <common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange"
                         @page-change="handlePageChange"></common-pagination>
      <IdentitylistDialog :dialogVisible="dialogVisible" :dialogTitle="dialogTitle" :dialogType="dialogType"
                          :handle_row="handle_row" :width="width" @close="handleDialogClose"
                          @cancel="handelDialogCancel">
      </IdentitylistDialog>
    </div>
  </div>
</template>

<script>
import {
  getLog, clearLog
} from "@/api/auth";
import CommonPagination from "@/components/CommonPagination";
import IdentitylistDialog from "./components/IdentitylistDialog";
import {
  mapState
} from "vuex";
import operations from "@/mixins/operations";

export default {
  name: "operationLog",
  mixins: [operations],
  data() {
    return {
      tableData: [],
      dataForm: {
        name: '',
        startTime: '',
        endTime: ''
      },
      time: [],
      page_index: 1, //第几页
      page_size: 10,
      total: 100, //总条数
      dialogVisible: false,
      dialogTitle: "",
      dialogType: "",
      handle_row: {},
      three_rules: [],
      width: ""
    };
  },
  components: {
    CommonPagination,
    IdentitylistDialog
  },
  computed: {
    ...mapState(["operationList"])
  },
  mounted() {
    this.getLogList();
  },
  methods: {
    async delLog() {
      const {
        status
      } = await clearLog();
      if (status !== 200) return
      this.$message.success("清除成功");
      await this.getLogList()
    },
    async getLogList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size,
        username: this.dataForm.username,
        start_time: this.dataForm.startTime,
        end_time: this.dataForm.endTime
      };
      const {
        data,
        status
      } = await getLog(postData);
      if (status !== 200) return;
      this.tableData = data.result.data;
      this.total = data.result.total;
    },
    addIdentityClick() {

      this.$router.push("/add-role");
    },
    editIdentityClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.$router.push({
        path: "/edit-role",
        query: {
          id: row.id
        }
      });

    },
    deleteIdentityClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogType = "delete";
      this.dialogTitle = "删除身份";
      this.dialogVisible = true;
      this.width = "30%";
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this.getLogList();
    },
    handlePageChange(page) {
      this.page_index = page;
      this.getLogList();
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this.getLogList();
    },
    handelDialogCancel() {
      this.dialogVisible = false;
    },
    onChangeDateChange() {
      this.dataForm.startTime = this.time[0]
      this.dataForm.endTime = this.time[1]
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
  .addBtn();
}

.table-wrap {
  .table-wrap();
}
</style>
